import { render, staticRenderFns } from "./TypeWellProvider.vue?vue&type=template&id=f369eb92"
import script from "./TypeWellProvider.vue?vue&type=script&lang=ts"
export * from "./TypeWellProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports